import React from "react";
import { useState } from "react";
import { CustomTab, CustomTabs } from "../../components/tabs/Tabs";
import Notification from "./Notification";

const NotificationManagement = () => {
  const tabsValue = localStorage.getItem("NotificationTabs") || "1";
  const [type, setType] = useState(tabsValue);
  localStorage.setItem("NotificationTabs", type);
  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Notification Management</h4>
            <div className="form-group tabs">
              <CustomTabs
                value={type}
                onChange={(e, section) => {
                  setType(section);
                }}
                aria-label="Content"
                variant="fullWidth"
              >
                <CustomTab value="1" label="Sent Notifications" />
                <CustomTab value="2" label="Scheduled" />
              </CustomTabs>
            </div>
          </div>
          <Notification type={type} />
        </div>
      </div>
    </>
  );
};

export default NotificationManagement;
